import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 py-20 overflow-hidden bg-[#050505] text-[#f5f0e8]" data-id="element-58">
      {/* Background Noise Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none bg-[url('https://grainy-gradients.vercel.app/noise.svg')] mix-blend-overlay" data-id="element-59"></div>

      {/* Radial Gradient Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-yellow-600/10 rounded-full blur-[120px] pointer-events-none" data-id="element-60"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-61">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-62">
          <span className="inline-block py-1 px-3 rounded-full border border-yellow-900/30 bg-yellow-900/10 text-yellow-500 text-xs tracking-widest uppercase mb-6" data-id="element-63">
            Identidad rentable + Protocolo Plano
          </span>

          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl font-bold tracking-tight leading-[1.1] mb-6" data-id="element-64">
            TRADING EN{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#b8942e] via-[#d4af37] to-[#e8c84a]" data-id="element-65">
              PAZ
            </span>
          </h1>

          <p className="text-xl md:text-2xl text-[#8a8578] max-w-2xl mx-auto font-light leading-relaxed mb-8" data-id="element-66">
            El sistema mental que te mantiene plano —{' '}
            <br className="hidden md:block" data-id="element-67" />
            <span className="text-[#f5f0e8]" data-id="element-68">sin euforia, sin venganza.</span>
          </p>

          <motion.button onClick={scrollToPricing} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} animate={{
          boxShadow: ['0 0 0px rgba(212,175,55,0)', '0 0 20px rgba(212,175,55,0.3)', '0 0 0px rgba(212,175,55,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity
          }
        }} className="mb-12 px-8 py-4 bg-gradient-to-r from-[#b8942e] via-[#d4af37] to-[#e8c84a] text-black font-bold text-lg tracking-wide rounded shadow-lg hover:shadow-yellow-500/20 transition-all" data-id="element-69">
            QUIERO OPERAR EN PAZ
          </motion.button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.8
      }} className="relative w-full max-w-3xl mx-auto mb-16" data-id="element-70">
          {/* Gold Glow behind image */}
          <div className="absolute inset-0 bg-yellow-500/20 blur-[60px] rounded-full transform scale-75" data-id="element-71"></div>

          <img src="https://cdn.magicpatterns.com/uploads/uBsbLjcCL3Zh7KUEvQoEGP/Imagen_5_del_producto.png" alt="Trading en Paz Product Mockup" className="relative z-10 w-full h-auto drop-shadow-2xl" data-id="element-72" />
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 1
      }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[#8a8578]" data-id="element-73">
          <span className="text-xs uppercase tracking-widest opacity-60" data-id="element-74">
            Descubre la verdad
          </span>
          <ChevronDown className="w-6 h-6 animate-bounce text-[#d4af37]" data-id="element-75" />
        </motion.div>
      </div>
    </section>;
}